import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter(
{
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: "/list",
        name: "list",
        component: () => import("@/views/ListView.vue"),
    },
    {
        path: "/map",
        name: "地图",
        component: () => import("@/views/MapView.vue"),
        meta:
        {
            keepAlive: true
        }
    },
    {
        path: "/pay",
        name: "支付",
        component: () => import("@/views/PayView.vue"),
    },
    {
        path: "/map_search",
        name: "地图搜索",
        component: () => import("@/views/MapSearchView.vue")
    },
    {
        path: "/newHouse",
        name: "新房详情",
        component: () => import("@/views/NewHouseView.vue")
    },
    {
        path: "/qr_upload",
        name: "图片上传",
        component: () => import("@/views/QrUploadView.vue")
    },
    {
        path: "/new_map",
        name: "新地图",
        component: () => import("@/views/NewMapView.vue")
    }]
})

export default router